import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { useIntercom } from "react-use-intercom";
import { AppStore, calling, PlayStore } from "../../assets/assets";
import Callback from "../../Modal/Callback";
import WriteToUs from "../../Modal/WriteToUs";
import httpApiCall from "../../service/api.service";
import { getStorageValue } from "../../service/shared.service";
import toastr from "../elements/toast";
import "./Support.scss";

const Support = () => {
  const partnerInfo = getStorageValue("partnerData")
  const { show } = useIntercom();
  const toastrService = new toastr(true);
  const answer = useSelector((state: any) => state?.APIData?.partnerData);
  let supportData = useSelector((state: any) => state?.APIData?.getSetting?.support_data);
  supportData = supportData && supportData.length ? supportData : partnerInfo?.support_data
  const [writeModalShow, setWriteModalShow] = useState(false);
  const [requestBack, setRequestBack] = useState();
  const navigate = useNavigate();
  const [callback, setCallBack] = useState(false);
    const rightArrow = {
    svg: (
      <svg
        _ngcontent-pdc-c68=""
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          _ngcontent-pdc-c68=""
          d="M14.4297 5.93018L20.4997 12.0002L14.4297 18.0702"
          stroke="#CBD1D9"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
        <path
          _ngcontent-pdc-c68=""
          d="M3.5 12H20.33"
          stroke="#CBD1D9"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
      </svg>
    ),
  };


  // console.log(supportData, "supportDatasupportDatasupportData");
  
  const navigeteRoute = async (path: any) => {
    navigate(path)
  }

  const requestCallBack = async () => {
    let body = {
      access_token: answer && answer.partner_profile &&  answer.partner_profile[0]["access_token"],
    };
    await httpApiCall({ api: "fetch_all_callback_reasons", type: "POST", body })
      .then((data) => {
        if (data && !data.is_error) {
          setRequestBack(data.data);
          // console.log(data.data);
        } else {
          toastrService.showError(data.original_text || data.err);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <div className="container">
      <div className="supports">
        <div className="supports-wrapper">
          <div className="supports-wrapper-header">
            <div className="right">
              <h1 className="mb-2">Looking for product support?</h1>
              <p className="mb-4">
                Contact us and we will respond to your query as soon as
                possible. Provide detailed information about the issue you are
                facing to help us assist you effectively.
              </p>
            </div>
            <div className="left">
              {(supportData && supportData.support_mobile) ? (
              <span>
                <span className="me-2">
                 <img src={calling} alt="" />
                </span>
                  <>Call support: <span className="supports-numbers">{supportData && supportData.support_mobile}</span></>
                </span>
              ) : null}
            </div>
          </div>
          <div className="row">
            <div onClick={() => setWriteModalShow(true)} className="col-xl-6 col-12">
              <div className="supports-wrapper-controls mt-4">
                <div className="content">Write to us</div>
                <div className="right-arrow">{rightArrow.svg}</div>
              </div>
            </div>
            <div onClick={show} className="col-xl-6 col-12">
              <div className="supports-wrapper-controls mt-4">
                <div className="content">Chat With us</div>
                <div className="right-arrow">{rightArrow.svg} </div>
              </div>
            </div>

            <div onClick={() => {
                            setCallBack(true);
                            requestCallBack();
                          }} className="col-xl-6 col-12">
              <div className="supports-wrapper-controls mt-4">
                <div className="content">Have us call you back</div>
                <div className="right-arrow">{rightArrow.svg}</div>
              </div>
            </div>
           { !partnerInfo?.user_partner_info?.pu_id && (
             <div onClick={() => navigeteRoute('/app/training-list')} className="col-xl-6 col-12">
             <div className="supports-wrapper-controls mt-4">
               <div className="content">Manage Trainings</div>
               <div className="right-arrow">{rightArrow.svg} </div>
             </div>
           </div>
           )}

           
          </div>

          <div className="supports-footer">
            {/* <h5 className="mb-3">Download the App</h5>
            <div className="play-store-wrap"><span><img src={AppStore} alt="" /></span>
            <Link to=""> <span><img src={PlayStore} alt="" /></span> </Link> </div> */}
            {/* <div className="terms-conditions faq-wrap mt-3 cursor d-inline-block" onClick={() => navigate('/app/faqs')} >
              <p>
                Frequently Asked Questions
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M14.4297 5.93018L20.4997 12.0002L14.4297 18.0702"
                      stroke="#131921"
                      strokeWidth="1.5"
                      strokeMiterlimit="10"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M3.5 12H20.33"
                      stroke="#131921"
                      strokeWidth="1.5"
                      strokeMiterlimit="10"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              </p>
            </div> */}
            <div className="terms-conditions mt-2 notranslate"><Link  to="/Terms">Terms & Conditions</Link></div>
          </div>
        </div>
      </div>

      {writeModalShow && (
                          <WriteToUs
                            show={writeModalShow}
                            onHide={() => setWriteModalShow(false)}
                          />
                        )}
                        {callback && (
                          <Callback
                            show={callback}
                            onHide={() => setCallBack(false)}
                            request={requestBack}
                          />
                        )}
    </div>
  );
};

export default Support;
